<!------------------------------------------------------------------------------------>
<!---------------------------- 공사 기간별 일반결제 내역-------------------------------->
<!------------------------------------------------------------------------------------>
<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet width="100%" height="100%" class="overflow-hidden overflow-y-auto mt-5">
      <i-search-panel :searchPanel="searchPanel"></i-search-panel>
      <DxDataGrid
        id="grid"
        class="layout-col-height02"
        style="width: 100%; height:100%"
        :ref="gridRef"
        :data-source="gridData"
        :remote-operations="false"
        :hover-state-enabled="true"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :row-alternation-enabled="true"
        :column-auto-width="true"
        :show-borders="true"
        :show-row-lines="true"
        :focused-row-enabled="true"
        :selection="{ mode: 'single' }"
        key-expr="transactionKey"
      >
        <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />
        <DxColumn data-field="userCd" data-type="string" :visible="false"></DxColumn>
        <DxColumn data-field="orderId" data-type="string" alignment="center" width="200px" caption="주문번호" :allow-editing="false" />
        <DxColumn data-field="paymentMethodType" data-type="string" alignment="center" width="100px" caption="결제종류" :allow-editing="false" />
        <DxColumn data-field="paymentMethod" data-type="string" alignment="center" width="150px" caption="결제방식" :allow-editing="false" />
        <DxColumn
          data-field="constructDtS"
          data-type="string"
          alignment="center"
          width="150px"
          caption="공사 시작일"
          :allow-editing="false"
          cell-template="dateTemplate"
        />
        <DxColumn
          data-field="constructDtE"
          data-type="string"
          alignment="center"
          width="150px"
          caption="공사 종료일"
          :allow-editing="false"
          cell-template="dateTemplate"
        />
        <DxColumn data-field="clntNm" data-type="string" alignment="center" width="200px" caption="고객사 명" :allow-editing="false" />
        <DxColumn data-field="constructNm" data-type="string" alignment="center" width="200px" caption="사업장(공사)명" :allow-editing="false" />
        <DxColumn data-field="approvedAt" data-type="string" alignment="center" width="200px" caption="거래 시간" :allow-editing="false" />
        <DxColumn data-field="feeName" data-type="string" alignment="center" width="200px" caption="요금제명" :allow-editing="false" />
        <DxColumn
          data-field="feeAmountMonth"
          data-type="number"
          alignment="right"
          width="120px"
          caption="월 요금"
          :allow-editing="false"
          cell-template="amountCellTemplate"
        />
        <DxColumn
          data-field="paymentAmount"
          name="paymentAmount"
          data-type="number"
          alignment="right"
          width="150px"
          caption="결제 금액"
          :allow-editing="false"
          header-cell-template="tooltip-payment-header"
          cell-template="amountCellTemplate"
        />
        <DxColumn
          data-field="feeAmount"
          name="feeAmount"
          data-type="number"
          alignment="right"
          width="150px"
          caption="요금 금액"
          :allow-editing="false"
          header-cell-template="tooltip-amount-header"
          cell-template="amountCellTemplate"
        />
        <DxColumn
          data-field="extraAmount"
          name="extraAmount"
          data-type="number"
          alignment="right"
          width="120px"
          caption="컨설팅 금액"
          :allow-editing="false"
          cell-template="amountCellTemplate"
        />
        <DxColumn
          data-field="vat"
          name="vat"
          data-type="number"
          alignment="right"
          width="120px"
          caption="VAT"
          :allow-editing="false"
          cell-template="amountCellTemplate"
        />
        <DxColumn
          data-field="tossCommission"
          name="fee"
          data-type="number"
          alignment="right"
          width="120px"
          caption="수수료"
          :allow-editing="false"
          header-cell-template="tooltip-fee-header"
          cell-template="amountCellTemplate"
        />
        <DxColumn
          data-field="payOutAmount"
          name="payOutAmount"
          data-type="number"
          alignment="right"
          caption="지급액"
          width="150px"
          :allow-editing="false"
          header-cell-template="tooltip-payout-header"
          cell-template="amountCellTemplate"
        />
        <DxColumn
          data-field="tossStatus"
          data-type="string"
          alignment="center"
          caption="정산 승인"
          width="120px"
          cell-template="tossStatusTemplate"
          header-cell-template="tooltip-status-header"
          :allow-editing="false"
        />
        <DxColumn data-field="paidOutDate" data-type="string" alignment="center" caption="정산일" width="120px" :allow-editing="false" />
        <template #dateTemplate="{ data: cellInfo }">
          <div class="d-flex justify-center">
            {{ formatDate(cellInfo.value) }}
          </div>
        </template>
        <template #tossStatusTemplate="{ data: cellInfo }">
          <div class="d-flex justify-center">
            <div v-if="cellInfo.data.tossStatus === '-'" style="color:#0e1113;">{{ '-' }}</div>
            <div v-else-if="cellInfo.data.tossStatus === 'Y'" style="color:#1B53F3;">{{ '승인' }}</div>
            <div v-else style="color:#FF2D2D;">{{ '미처리' }}</div>
          </div>
        </template>
        <template #amountCellTemplate="{ data: cellInfo  }">
          <div v-if="cellInfo.value === '-'">{{ '-' }}</div>
          <div v-else>{{ formatToKoreanWon(cellInfo.value) + '원' }}</div>
        </template>
        />
        <!-- 요금 금액 -->
        <template #tooltip-amount-header="{ data }">
          <div>
            {{ data.column.caption }}
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>{{ '컨설팅 비용 포함' }}</span>
            </v-tooltip>
          </div>
        </template>
        <!-- 결제 금액 -->
        <template #tooltip-payment-header="{ data }">
          <div>
            {{ data.column.caption }}
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>{{ 'VAT 포함' }}</span>
            </v-tooltip>
          </div>
        </template>
        <!-- 수수료  -->
        <template #tooltip-fee-header="{ data }">
          <div>
            {{ data.column.caption }}
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>{{ 'PG사(토스) 결제 건당 수수료 (정산 승인 이후 반영)' }}</span>
            </v-tooltip>
          </div>
        </template>
        <!-- 지급액  -->
        <template #tooltip-payout-header="{ data }">
          <div>
            {{ data.column.caption }}
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>{{ '지급액 = 결제 금액 - 수수료' }}</span>
            </v-tooltip>
          </div>
        </template>
        <!-- 정산 승인 -->
        <template #tooltip-status-header="{ data }">
          <div>
            {{ data.column.caption }}
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>{{ 'PG사(토스) 결제 확인 상태' }}</span>
            </v-tooltip>
          </div>
        </template>
        <!-- 금액 요약 -->
        <DxSummary :calculate-custom-summary="customSummary">
          <DxTotalItem column="orderId" summary-type="count" display-format="{0}건" />
          <DxTotalItem column="paymentAmount" name="paymentAmount" summary-type="custom" display-format="{0}원" :customize-text="customizeText" />
          <DxTotalItem column="extraAmount" name="extraAmount" summary-type="custom" display-format="{0}원" :customize-text="customizeText" />
          <DxTotalItem column="tossCommission" name="tossCommission" summary-type="custom" display-format="{0}원" :customize-text="customizeText" />
          <DxTotalItem column="payOutAmount" name="payOutAmount" summary-type="custom" display-format="{0}원" :customize-text="customizeTotalText" />
        </DxSummary>
      </DxDataGrid>
    </v-sheet>
  </v-container>
</template>
<script>
import iSearchPanel from '@/components/common/iSearchPanel.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
// 출력 관련
import { Workbook } from 'exceljs'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import { saveAs } from 'file-saver-es'
import { exportDataGrid as exportExcel } from 'devextreme/excel_exporter'
import { exportDataGrid as exportPdf } from 'devextreme/pdf_exporter'
import malgun from '@/assets/font/malgun.ttf'
import { getNormalTossSettlementFromOrderHistory } from '@/api/feeManage/settlementHistory.js'
export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'pgNormalHistory',
  components: {
    iSearchPanel
  },
  props: {
    searchStartDate: {
      type: String,
      default: () => ''
    },
    searchEndDate: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      gridRef: 'pgNormalGrid',
      gridData: [],
      totalAmount: 0,
      searchPanel: true
    }
  },
  computed: {},
  beforeMount() {},
  activated() {},
  mounted() {},
  methods: {
    customizeText(options) {
      // 출력되는 합계금액 커스텀
      return this.formatToKoreanWon(options.value) + '원'
    },
    customizeTotalText(options) {
      // 출력되는 합계금액 커스텀
      return '합계: ' + this.formatToKoreanWon(this.totalAmount) + '원'
    },
    customSummary(options) {
      // 2025.01.10 LJH 음수도 계산하도록 수정
      // 토스 결제에서 음수 제외하고 합산 구하는 함수
      const dataSource = options.component.option('dataSource') // 데이터 소스에서 데이터를 가져오기
      const field = options.name
      let sum = 0
      if (dataSource.length > 0) {
        // summaryProcess가 finalize일 때 합산을 마무리
        if (options.summaryProcess === 'finalize') {
          dataSource.forEach(item => {
            sum += parseInt(item[field] != null ? item[field] : 0)
          })
          // summary 타입의 값을 설정
          options.totalValue = sum
          if (field === 'payOutAmount') {
            this.totalAmount += sum
          }
        }
      }
    },

    async btnSearch(param, isNotify = true) {
      // 토스 일반요금 정산 내역
      this.totalAmount = 0
      let searchStartDate = this.setFormatDate(param.searchStartDate, true)
      let searchEndDate = this.setFormatDate(param.searchEndDate, false)
      this.openLoading()
      getNormalTossSettlementFromOrderHistory({ searchStartDate: searchStartDate, searchEndDate: searchEndDate }, isNotify).then(res => {
        this.gridData = res.list.sort((a, b) => {
          const dateComparison = new Date(b.approvedAt) - new Date(a.approvedAt)
          if (dateComparison !== 0) return dateComparison
          if (a.paymentAmount < b.paymentAmount) return -1
          if (a.paymentAmount > b.paymentAmount) return 1
          return 0
        })
        this.endLoading()
      })
    },
    async btnPrint(type, title, docTitle) {
      if (type == 'xls') {
        const workbook = new Workbook()
        const worksheet = workbook.addWorksheet(title)
        exportExcel({
          component: this.GetDataGrid(this.gridRef),
          worksheet,
          autoFilterEnabled: true
        }).then(() => {
          workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${title}${docTitle}`)
          })
        })
      }
      if (type == 'pdf') {
        const doc = new jsPDF()
        doc.addFont(malgun, 'malgun', 'normal')

        exportPdf({
          jsPDFDocument: doc,
          component: this.GetDataGrid(this.gridRef),
          autoTableOptions: {
            styles: {
              font: 'malgun'
            }
          }
        }).then(() => {
          doc.save(`${title}.pdf`)
        })
      }
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    formatToKoreanWon(value) {
      if (value) {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      } else return 0
    },
    formatDate(date, div = '.') {
      if (!date) return null

      if (date.indexOf(div) == -1) {
        const year = date.substring(0, 4)
        const month = date.substring(4, 6)
        const day = date.substring(6, 8)
        return `${year}${div}${month}${div}${day}`
      } else if (date.indexOf(div) > -1) {
        const [year, month, day] = date.split(div)
        return `${year}${div}${month}${div}${day}`
      } else {
        return date
      }
    },
    setFormatDate(dateString, start) {
      const yearString = dateString.substring(0, 4)
      const monthString = dateString.substring(4, 6)
      const date = new Date(`${yearString}.${monthString}`)
      let year = date.getFullYear()
      let month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`
      // 다음 달의 첫 번째 날 설정
      const firstDayOfNextMonth = new Date(year, month, 1)
      // 다음 달 첫째 날에서 하루 빼기
      const lastDay = new Date(firstDayOfNextMonth - 1)
      let day = lastDay.getDate()

      return start ? `${year}-${month}-01` : `${year}-${month}-${day}`
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/theme/variables.scss';
</style>
